import React from "react";
import Banner from "../../components/UserSideComponents/termsConditions/Banner";
import Conditions from "../../components/UserSideComponents/termsConditions/Conditions";
import Acceptance from "../../components/UserSideComponents/termsConditions/Acceptance";
import MemberShip from "../../components/UserSideComponents/termsConditions/MemberShip";
import MemberConduct from "../../components/UserSideComponents/termsConditions/MemberConduct";
import SubmitContent from "../../components/UserSideComponents/termsConditions/SubmitContent";
import CopyRight from "../../components/UserSideComponents/termsConditions/CopyRight";
import Modification from "../../components/UserSideComponents/termsConditions/Modification";
import Property from "../../components/UserSideComponents/termsConditions/Property";
import Resolution from "../../components/UserSideComponents/termsConditions/Resolution";
import Advertisements from "../../components/UserSideComponents/termsConditions/Advertisements";
import ThirdParty from "../../components/UserSideComponents/termsConditions/ThirdParty";
import Warranties from "../../components/UserSideComponents/termsConditions/Warranties";
import Limitations from "../../components/UserSideComponents/termsConditions/Limitations";
import Indemnification from "../../components/UserSideComponents/termsConditions/Indemnification";
import Benificiaries from "../../components/UserSideComponents/termsConditions/Benificiaries";
import Notice from "../../components/UserSideComponents/termsConditions/Notice";
import Information from "../../components/UserSideComponents/termsConditions/Information";
import Offers from "../../components/UserSideComponents/termsConditions/Offers";
import Referral from "../../components/UserSideComponents/termsConditions/Referral";
import Booking from "../../components/UserSideComponents/termsConditions/Booking";
import FraudulentActivities from "../../components/UserSideComponents/termsConditions/FraudulentActivities";

const TermsConditions = () => {
  return (
    <div>
      <Banner />
      <Conditions />
      <Acceptance />
      <MemberShip />
      <MemberConduct />
      <SubmitContent />
      <CopyRight />
      <Modification />
      <Property />
      <Resolution />
      <Advertisements />
      <ThirdParty />
      <Warranties />
      <Limitations />
      <Indemnification />
      <Benificiaries />
      <Notice />
      <Information />
      <Offers />
      <Referral />
      <Booking />
      <FraudulentActivities />
    </div>
  );
};

export default TermsConditions;
